export enum EPlatform {
	/** Android */
	android = "android",
	/** iOS */
	ios = "ios",
	/** Unit Tests */
	test = "test",
	/** Web App */
	browser = "browser"
}